/** Packages * */
import React from 'react';
import PropTypes from 'prop-types';

import './styles.scss';
import { useLanguage } from '../../context/LanguageContext';

const Loader = props => {
  const { labels } = useLanguage();
  const LOADING = labels.LOADING || 'Loading...';
  return (
    <section className={`row expanded loader-container ${props.className}`}>
      <div className='large-12 columns'>
        <div key={0} className='row expanded'>
          <p>{LOADING}</p>
          <div className='loader' />
        </div>
      </div>
    </section>
  );
};

Loader.propTypes = {
  className: PropTypes.string
};

Loader.defaultProps = {
  className: ''
};

export default Loader;
